import { motion } from "framer-motion";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_1372e601-3756-4090-a4b3-dfd0e81eaf5a/artifacts/djc1777r_Muscle%20Mineral%20Logo.png";

export const AboutBrand = () => {
  return (
    <section 
      id="about"
      className="py-24 md:py-32 bg-[#0A0A0A]"
      data-testid="about-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Brand info */}
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="font-mono text-sm tracking-[0.3em] text-[#E82D00] mb-4"
            >
              ABOUT THE BRAND
            </motion.p>

            {/* Logo */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mb-8"
            >
              <img 
                src={LOGO_URL} 
                alt="Muscle Mineral" 
                className="h-16 md:h-20 w-auto invert"
                data-testid="about-logo"
              />
            </motion.div>

            {/* Tagline */}
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-3xl md:text-4xl lg:text-5xl font-bold uppercase tracking-tight text-white mb-8 leading-tight"
              style={{ fontFamily: 'Oswald, sans-serif' }}
              data-testid="about-tagline"
            >
              Forged by the Elements.<br />
              <span className="text-[#A3A3A3]">Backed by Science.</span>
            </motion.h2>

            {/* Body text */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="space-y-6"
            >
              <p className="text-lg text-[#A3A3A3] leading-relaxed" data-testid="about-text-1">
                Muscle Mineral represents the pursuit of Elemental Strength — the precise integration of essential nutrients designed to elevate physical and cognitive performance.
              </p>
              <p className="text-lg text-[#E5E5E5] leading-relaxed" data-testid="about-text-2">
                More than ingredients, our nutrients are deployed as functional systems.
              </p>
            </motion.div>

            {/* Closing statement */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-10"
            >
              <p 
                className="text-2xl md:text-3xl font-bold uppercase tracking-tight text-white"
                style={{ fontFamily: 'Oswald, sans-serif' }}
              >
                Elemental Strength.<br />
                <span className="text-[#E82D00]">No Compromise.</span>
              </p>
            </motion.div>
          </div>

          {/* Right: Visual element */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
            data-testid="about-visual"
          >
            <div className="relative aspect-square max-w-md mx-auto">
              {/* Decorative elements */}
              <div className="absolute inset-0 border border-white/10" />
              <div className="absolute inset-4 border border-white/10" />
              <div className="absolute inset-8 border border-[#E82D00]/20" />
              
              {/* Center content */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <p className="font-mono text-xs tracking-[0.5em] text-[#A3A3A3] mb-4">EST. 2024</p>
                  <div className="w-20 h-px bg-[#E82D00] mx-auto mb-4" />
                  <p 
                    className="text-6xl md:text-7xl font-bold text-white/10"
                    style={{ fontFamily: 'Oswald, sans-serif' }}
                  >
                    MM
                  </p>
                  <div className="w-20 h-px bg-[#E82D00] mx-auto mt-4" />
                  <p className="font-mono text-xs tracking-[0.3em] text-[#A3A3A3] mt-4">SOUTH AFRICA</p>
                </div>
              </div>

              {/* Corner accents */}
              <div className="absolute top-0 left-0 w-8 h-8 border-l-2 border-t-2 border-[#E82D00]" />
              <div className="absolute top-0 right-0 w-8 h-8 border-r-2 border-t-2 border-[#E82D00]" />
              <div className="absolute bottom-0 left-0 w-8 h-8 border-l-2 border-b-2 border-[#E82D00]" />
              <div className="absolute bottom-0 right-0 w-8 h-8 border-r-2 border-b-2 border-[#E82D00]" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutBrand;
